import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['ShuttleIn', 'DispatchBoards', 'ShuttleInFrom', 'Parkings'],
});
export const shuttleInApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findShuttleInById: builder.query({
      query: (id) => `shuttle_in/${id}/`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'ShuttleIn', id: result.id }] : ['ShuttleIn'];
      },
    }),
    findCallingsheetsNewId: builder.query({
      query: (id) => `manage_callingsheets/?calling_no=${id}`,
    }),
    findCheckMatch: builder.query({
      query: (payload) => {
        let url = `shuttle_in/calling_vins/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ShuttleIn'],
    }),
    findCheckMatchShuttleOut: builder.query({
      query: (payload) => {
        let url = `shuttle_out/check/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ShuttleIn'],
    }),

    findShuttleInTrailerbyCardId: builder.query({
      query: (trailer_card_id) =>
        `trailers/?trailer_card_id=${trailer_card_id}`,
    }),

    findShuttleInDriverbyCode: builder.query({
      query: (tlep_code) => `drivers/?tlep_code=${tlep_code}`,
    }),

    findCurrentTimeShuttleIn: builder.query({
      query: () => `server_time/`,
      keepUnusedDataFor: 0,
      providesTags: ['ShuttleIn'],
    }),

    findPlanArrivalTime: builder.query({
      query: (payload) => {
        let url = `shuttle_in/plan_arrival_time/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ShuttleIn'],
    }),

    findParkingsByUser: builder.query({
      query: () => `user_parkings/`,
      keepUnusedDataFor: 0,
      providesTags: ['ShuttleIn'],
    }),

    updateShuttleInDispatchBoards: builder.mutation({
      query: (payload) => ({
        url: `dispatch_boards/${payload.id}/`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['ShuttleIn'],
    }),
    updateShuttleInShipmentTracking: builder.mutation({
      query: (payload) => ({
        url: `shipment_tracking/?dispatch_board_id=${payload.dispatch_board_id}&arrival_time=${payload.arrival_time}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['ShuttleIn'],
    }),

    createShuttleIn: builder.mutation({
      query: (payload) => {
        let url = `shuttle_in/confirm/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          console.log('key, value', key, value);
          if (value != null && key !== 'vins') {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return {
          url: `${url}?${searchParams.toString()}`,
          method: 'POST',
          body: payload,
        };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ShuttleIn'],
    }),

    updateShuttleOut: builder.mutation({
      query: (payload) => ({
        url: `shuttle_out/?shuttle_in_id=${payload.id}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['ShuttleIn'],
    }),

    findShuttleInReasonMasterByModule: builder.query({
      query: (module) => `reasons/?module__name=${module}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ShuttleIn', module: result.module }]
          : ['ShuttleIn'];
      },
    }),
    findShuttleInGroupReasonByCode: builder.query({
      query: (code) => `reasons/?&subject_reason__group__code=${code}`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'ShuttleIn', id: result.id }] : ['ShuttleIn'];
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindPlanArrivalTimeQuery,
  useFindShuttleInByIdQuery,
  useFindParkingsByUserQuery,
  useCreateShuttleInMutation,
  useFindCurrentTimeShuttleInQuery,
  useUpdateShuttleInShipmentTrackingMutation,
  useFindShuttleInReasonMasterByModuleQuery,
} = shuttleInApi;
